// sync-start:coediting-chunkify 11868810 https://github.com/Khan/webapp/blob/master/services/ai-guide/coediting/streaming.go

const blockSeparator = "\n\n";
const lineSeparator = "\n";
const listItemRegex = /(^|\n)[ \t]*(\d+\.|-|\*|\+) /;
const headingRegex = /(^|\n)#+ /;

export function chunkify(text: string): string[] {
    const chunks: string[] = [];

    for (const block of text.split(blockSeparator)) {
        if (listItemRegex.test(block) || headingRegex.test(block)) {
            for (const line of block.split(lineSeparator)) {
                chunks.push(trimNewlines(line));
            }
        } else {
            chunks.push(trimNewlines(block));
        }
    }

    return chunks;
}

const trimNewlines = (input: string) =>
    input.replace(/^\n+/, "").replace(/\n+$/, "");

// sync-end:coediting-chunkify
